'use client'

import PodCover from 'pageCores/pod-cover/PodCover'
import { FC } from 'react'

export const PodCoverContent: FC = () => {
	return <PodCover />
}
